import { Base, createApp, importWhenVisible } from '@studiometa/js-toolkit';
import { ModalWithTransition, ScrollReveal } from '@studiometa/ui';
import Figure from './atoms/Figure/Figure.js';
import Header from './organisms/Header.js';
import PageBuilder from './organisms/PageBuilder.js';
import Footer from './organisms/Footer.js';
import Elearning from './organisms/Elearning.js';
import AgeGate from './molecules/AgeGate.js';
import PopinConditional from './molecules/PopinConditional.js';
import ElearningModal from './molecules/ElearningModal.js';
import ScrollRevealParent from './atoms/ScrollRevealParent.js';
import ScrollRevealParentSummary from './atoms/ScrollRevealParentSummary.js';
import CanvasBubbles from './organisms/CanvasBubbles.js';
import AjaxForm from './molecules/AjaxForm.js';
import UserMenu from './molecules/UserMenu.js';
import LargeText from './atoms/LargeText.js';
import QuickAccess from './molecules/QuickAccess.js';
import ScrollRevealTitle from './atoms/ScrollRevealTitle.js';
import ScrollRevealClassNames from './atoms/ScrollRevealClassNames.js';
import QuizStart from './organisms/QuizStart.js';

/**
 * App
 */
class App extends Base {
  /**
   * App Configuration
   */
  static config = {
    name: 'App',

    components: {
      AgeGate,
      Header,
      Elearning,
      Footer,
      PageBuilder,
      ScrollRevealParent,
      ScrollRevealParentSummary,
      Figure,
      PopinConditional,
      AjaxForm,
      CanvasBubbles,
      UserMenu,
      LargeText,
      ElearningModal,
      QuizStart,
      ScrollRevealTitle,
      ScrollRevealClassNames,
      ScrollReveal,
      ModalWithTransition,
      QuickAccess,
      Results: (app) => importWhenVisible(() => import('./molecules/Results.js'), 'Results', app),
      SliderWithBreakpoint: (app) =>
        importWhenVisible(
          () => import('./molecules/SliderWithBreakpoint.js'),
          'SliderWithBreakpoint',
          app,
        ),
      Webform: (app) => importWhenVisible(() => import('./molecules/Webform.js'), 'Webform', app),
      ListingWithMap: (app) =>
        importWhenVisible(
          () => import('./organisms/ListingWithMap/index.js'),
          'ListingWithMap',
          app,
        ),
      Quiz: (app) => importWhenVisible(() => import('./molecules/Quiz/index.js'), 'Quiz', app),
      QuizRank: (app) =>
        importWhenVisible(() => import('./molecules/QuizRank/index.js'), 'QuizRank', app),
      Location: (app) =>
        importWhenVisible(() => import('./molecules/Location/index.js'), 'Location', app),
      SchoolLocation: (app) =>
        importWhenVisible(
          () => import('./molecules/SchoolLocation/index.js'),
          'SchoolLocation',
          app,
        ),
      FileUpload: (app) =>
        importWhenVisible(() => import('./atoms/FileUpload.js'), 'FileUpload', app),
    },
  };

  /** @inheritdoc */
  mounted() {
    // eslint-disable-next-line dot-notation
    window['console'].log(
      '%c Made with ❤ by Studio Meta %c https://www.studiometa.fr',
      'display: inline-block; background-color: #b69e64; color: #ffffff; font-weight: 500; margin-top: 8px; margin-bottom: 8px; padding: 8px; text-decoration: none !important; border: 2px solid #b69e64;',
      'display: inline-block; background-color: transparent; color: currentColor; font-weight: 500; margin-top: 8px; margin-bottom: 8px; padding: 8px; text-decoration: none !important; border: 2px solid #b69e64;',
    );
    this.setBrowser();
  }

  /**
   * Set Browser
   */
  setBrowser() {
    let browser = 'unknow';

    if (navigator.userAgent.includes('Chrome')) {
      browser = 'chrome';
    } else if (navigator.userAgent.includes('Safari')) {
      browser = 'safari';
    } else if (navigator.userAgent.includes('Opera')) {
      browser = 'opera';
    } else if (navigator.userAgent.includes('Firefox')) {
      browser = 'firefox';
    } else if (navigator.userAgent.includes('MSIE') || navigator.userAgent.includes('Trident')) {
      browser = 'ie';
    }

    document.querySelector('html').classList.add(`is-${browser}`);
  }

  /**
   * resized hook
   */
  resized() {
    this.appHeight();
  }

  /**
   * Set real --vh css prop to have a real 100vh value.
   * Use class .min-h-real-screen
   */
  appHeight = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  };
}

export default createApp(App, document.body);
